import React from 'react'
import { IProps } from './index'
import { GridContainer } from 'marketing-site/src/mvp/library/components/GridContainer'
import classNames from 'classnames'
import kebabCase from 'lodash.kebabcase'

export const CardsWithImage = ({
  title,
  eyebrow,
  subhead,
  backgroundColor = 'transparent',
  cta,
  cards,
  layout = '3-3',
  bodyAlignment = 'start',
}: IProps): React.ReactElement => {
  const classes = classNames('cards-with-image', {
    [`mvp-background-color-${kebabCase(backgroundColor)}`]: backgroundColor,
  })
  return (
    <>
      <div className={classes} data-testid="cards-with-image">
        <GridContainer
          layout={layout}
          eyebrow={eyebrow}
          title={title}
          titleSize="heading-2"
          subhead={subhead}
          cta={cta}
          ctaPosition="below-header"
          bodyColumnGap="default"
          bodyRowGap="large"
          body={cards}
          bodyAlignment={bodyAlignment}
          backgroundColor={backgroundColor}
        />
      </div>
      <style jsx>{`
        .cards-with-image {
          :global(.grid-container) {
            padding-top: 0;
            padding-bottom: 0;
          }

          :global(.grid-container__header + .grid-container__body) {
            margin-top: 0;
          }
        }
      `}</style>
    </>
  )
}
